import { observer } from 'mobx-react-lite'
import { type ReactNode } from 'react'
import { numberFormat } from 'shared/lib'
import { type IRowDefault, type TableStore } from 'shared/ui/TableNew'
import styles from './styles.module.scss'

export type IHeaderLeftContentProps = { actionsContent?: ReactNode }

export const HeaderLeftContent = observer(
  <TRow extends IRowDefault>({
    actionsContent,
    store,
  }: IHeaderLeftContentProps & {
    store: TableStore<TRow>
  }) => {
    const { total } = store
    const { selectedIds, bulkAllMode, bulkTotal } = store.bulkStore
    let selectedCount: number

    if (bulkAllMode) {
      selectedCount = bulkTotal === total ? total : bulkTotal
    } else {
      selectedCount = selectedIds.length
    }

    return (
      <>
        <div className={styles.container}>
          {`${numberFormat({ value: selectedCount })} selected`}{' '}
        </div>
        <div className={styles.actionsWrap}>{actionsContent}</div>
      </>
    )
  }
)
